'use client';

import { HeroUIProvider } from '@heroui/react';
import { ReCaptchaProvider } from 'next-recaptcha-v3';
import { Toaster } from 'react-hot-toast';
import type { ReactNode } from 'react';

interface ProvidersProps {
  children: ReactNode;
  recaptchaSiteKey?: string | null;
}

export default function Providers({
  children,
  recaptchaSiteKey,
}: ProvidersProps) {
  return (
    <HeroUIProvider>
      <Toaster position="top-right" />
      <ReCaptchaProvider useEnterprise reCaptchaKey={recaptchaSiteKey ?? ''}>
        {children}
      </ReCaptchaProvider>
    </HeroUIProvider>
  );
}
